import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Gallery,GalleryService } from './gallery.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}
@Component({
    selector: 'gallery-component',
	//template: require('./galleryhome.component.html')
	templateUrl: './pg/gallery/galleryhome.component.html'
	
})

export class GalleryHomeComponent implements OnInit {
	
	
	pagedata: PageData;
	public headingtitle;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public gallery:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _pageService: GalleryService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   
			  let limit="8";
			let compservice=document.querySelector('gallery-component');
			if(compservice){
			if(compservice.getAttribute('limit'))
			{
				limit=compservice.getAttribute('limit');
			}
			} 			   
			   
			   this._pageService.getGallerylist(null,limit).subscribe(
        data => {
                              
                                  
                  this.gallery=data.gallery;
                  this.headingtitle=data.menu.link_showing_name;                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		}); 
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/gallery/galleryhome.component.ts